/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { CampaignState } from 'cio/models/campaign';
import SubscriptionTopicUsage from 'cio/utils/subscription-topic-usage';

interface SubscriptionTopicUsageArgs {
  usage: SubscriptionTopicUsage;
  topicID: string;
}

export default class SubscriptionTopicUsageSummary extends Component<SubscriptionTopicUsageArgs> {
  get usage() {
    return ['campaigns', 'broadcasts', 'newsletters']
      .map((type: keyof SubscriptionTopicUsage) => {
        return {
          type,
          count: this.args.usage[type].length ?? 0,
          singularLabel: type === 'broadcasts' ? 'API Triggered broadcast' : type.slice(0, -1),
        };
      })
      .filterBy('count');
  }

  get routes() {
    let defaultRunningQueryParams = {
      subscriptionTopicId: this.args.topicID,
      state: CampaignState.Running,
    };
    return {
      campaigns: {
        route: 'campaigns.index',
        query: {
          ...defaultRunningQueryParams,
        },
      },
      newsletters: {
        route: 'broadcasts.list.newsletters.index',
        query: {
          subscriptionTopicId: this.args.topicID,
          type: 'scheduled',
        },
        broadcasts: {
          route: 'broadcasts.list.api-triggered.index',
          query: {
            ...defaultRunningQueryParams,
          },
        },
      },
    };
  }
}
